import {Box} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {PageEnvironmentBanner} from '../../../app-shell/environment-banner'
import {DriverJobPage} from '../../../driver-view/driver-job-page'
import {GoogleMapsProvider} from '../../../jobs/google-maps/google-maps-provider'

type DriverJobSearch = {
    access: string
}

export const Route = createFileRoute('/driver/jobs/$jobId')({
    validateSearch: (search: Record<string, unknown>): DriverJobSearch => ({
        access: typeof search.access === 'string' ? search.access : '',
    }),
    component: DriverJobRoute,
})

function DriverJobRoute() {
    const {jobId} = Route.useParams()
    const {access} = Route.useSearch()

    return (
        <GoogleMapsProvider>
            <PageEnvironmentBanner />
            <Box maw={480} mx="auto" px="md" py="md">
                <DriverJobPage jobId={jobId} accessToken={access} />
            </Box>
        </GoogleMapsProvider>
    )
}
